import AiDraftedFieldsTracker from './AiDraftedFieldsTracker.component';

export default AiDraftedFieldsTracker;
